<template>
    <div class="homePage">
        <div class="bgBox"></div>
        <div class="container">
             <div class="upload_btn" @click="forgetPwd">
                <Button>修改密码</Button>
            </div>
            <div class="search-header">
                <div class="search_box">
                    <Input v-model="keyName" placeholder="输入搜索关键词..." :border="false" class="inputInner" />
                    <div class="search_btn" @click="search">
                        搜索
                    </div>
                </div>
            </div>
            <div class="results-main-container">
                <div class="search-results-list">
                    <div class="result-item" v-for="(item, index) in dataList" :key="index">
                        <div class="flex1 CellGroup" style="align-items: center;" v-if="item.isNew">
                            <div class="name">检索结果:{{ item.name }}</div>
                            <div>
                                <Input search enter-button="保存" placeholder="备注" @on-search="addItem" />
                            </div>
                        </div>
                        <div class="flex1 CellGroup" v-else>
                            <div class="name">检索结果:{{ item.name }}</div>
                            <div class="note">备注:{{ item.description }}</div>
                            <div>检索次数:{{ item.num }}</div>
                        </div>
                    </div>
                </div>
                <Page class="page" :current="pageNum" :total="total" simple @on-change="changePage" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            keyName: '',
            dataList: [],
            pageNum: 1,
            total: 0,
            content: ""
        }
    },
    mounted() {
        // this.getList();
        if(!localStorage.getItem('token')){
            this.$router.push('/login')
        }
    },
    methods: {
        search() {
            if (this.keyName.trim() === '') {
                this.$Message.warning('请输入搜索关键词');
                return;
            }
            this.getList();
        },
        getList() {
            const that = this;
            that.$axios({
                url: '/api/index/image_search',
                method: 'post',
                data: {
                    page: this.pageNum,
                    key: this.keyName
                }
            }).then(res => {
                this.dataList = res.data.list;
                this.total = res.data.count;
                if (res.data.list && !res.data.list.length && this.keyName.trim() !== '') {
                    this.dataList.push({
                        name: this.keyName,
                        description: '',
                        isNew:true
                    })
                }
            })
        },
        changePage(page) {
            this.pageNum = page;
            this.getList();
        },
        addItem(value) {
            const that = this;
            if (value.trim() === '') {
                this.$Message.warning('请输入备注内容');
                return;
            }
            that.$axios({
                url: '/api/index/upload_img',
                method: 'post',
                data: {
                    name: this.keyName,
                    description: value
                }
            }).then(res => {
                that.$Message.info('保存成功');
                that.page = 1;
                that.getList();
            })
        },
        forgetPwd() {
            this.$router.push('/forget-password')
        },
    },
}
</script>

<style lang="scss" scoped>
.homePage {
    .bgBox {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
        background: url('../assets/imgs/bg_img@2x.png') no-repeat;
        background-size: cover;
        background-position: center;
        backdrop-filter: blur(5px);
        opacity: 0.8;
    }

    .container {
        max-width: 1020px;
        margin: 0 auto;
        padding: 70px 20px 20px;
        width: 80vw;
    }

    
    .upload_btn {
        position: fixed;
        top: 20px;
        right: 40px;
        z-index: 100;
        display: flex;
        align-items: center;
        border: 1px solid #6f55ff;
        border-radius: 16px;
        background: linear-gradient(-12deg, #6f55ff, #47fcff);

        /deep/.ivu-upload {
            width: 100px !important;
        }

        /deep/.ivu-btn {
            background: transparent !important;
            border: none !important;
            width: 100px !important;
            color: #6f55ff !important;
            font-weight: bold !important;
        }
    }

    .search-header {
        width: 100%;
        box-sizing: border-box;
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 12px;
        padding: 20px;
        backdrop-filter: blur(10px);
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        margin-bottom: 25px;

        .search_box {
            position: relative;
            width: 100%;
            max-width: 600px;
            display: flex;
            align-items: center;
            margin: 14px auto;
            border-radius: 50px;
            padding: 2px;
            background: linear-gradient(-12deg, #6f55ff, #47fcff);
            box-shadow: 0 4px 20px rgba(111, 85, 255, 0.25);
            animation: fadeIn 1.2s;

            .inputInner {
                display: flex;
                align-items: center;
                width: 100%;
                background-color: #fff;
                border-radius: 48px;
                padding: 4px;
            }

            /deep/.ivu-input {
                border-radius: 48px !important;
                height: 42px !important;
                font-size: 16px !important;
                font-weight: 500 !important;
            }

            .search_btn {
                padding: 10px 10px;
                border: none;
                background: transparent;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: opacity 0.2s, transform 0.2s;
                gap: 6px;
                font-size: 1.1rem;
                font-weight: 600;
                white-space: nowrap;
                margin: 0 10px;
                position: absolute;
                right: 0;

                &:hover {
                    opacity: 0.8;
                    transform: scale(1.05);
                }
            }
        }
    }

    .results-main-container {
        width: 100%;
        box-sizing: border-box;
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 12px;
        padding: 20px;
        backdrop-filter: blur(10px);
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

        .search-results-list {
            display: flex;
            flex-direction: column;
            gap: 15px;
            min-height: 70vh;

            .result-item {
                background-color: #fff;
                border: 1px solid #e9e9e9;
                border-radius: 8px;
                padding: 20px;
                display: flex;
                align-items: flex-start;
                transition: box-shadow 0.3s ease, transform 0.3s ease;

                .flex1 {
                    flex: 1;
                }

                .CellGroup {
                    display: flex;
                    flex: 1;
                    overflow: hidden;
                    justify-content: space-between;
                    .name{
                        min-width: 150px;
                    }
                    .note{
                        margin: 0 20px;
                    }
                    div{
                        min-width: 100px;
                    }
                }
            }
        }

        .page {
            margin-top: 16px;
            text-align: right;
        }
    }
}
</style>